import { render, staticRenderFns } from "./PortalTeleAtendimento.vue?vue&type=template&id=74dd1980&"
import script from "./PortalTeleAtendimento.vue?vue&type=script&lang=js&"
export * from "./PortalTeleAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports